import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import siteContextStore, { GlobalLabels } from '@/shared/content/site-context.store';
import { router } from '@/core/router';
import useGlobalLabels from '@/shared/content/useGlobalLabels';
import RouterLinkConditional from '@/core/navigation/router-link-conditional.vue';
import { QueryKeys } from '@/shared/config/route-query.config';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutLoginLink',
  setup(__props) {

const globalLabels = useGlobalLabels(GlobalLabels.logInOrSignUp);

const returnUrl = computed(() => {
    return router.currentRoute.value.fullPath;
});

const loginUrl = computed(() => {
    return `${siteContextStore.settings.loginLink.url}?${QueryKeys.ReturnUrl}=${returnUrl.value}`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(RouterLinkConditional, {
    to: _unref(loginUrl),
    "spa-enabled": _unref(siteContextStore).settings.loginLink.spaLink
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(globalLabels).loginText), 1)
    ]),
    _: 1
  }, 8, ["to", "spa-enabled"]))
}
}

})